import _classCallCheck from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/createClass.js";
import "core-js/modules/es.json.stringify.js";

var AuthService = /*#__PURE__*/function () {
  function AuthService() {
    _classCallCheck(this, AuthService);
  }

  _createClass(AuthService, [{
    key: "user",
    get: function get() {
      return localStorage.getItem("user-data");
    }
  }, {
    key: "isAuthenticated",
    get: function get() {
      return localStorage.getItem("user-data") !== null;
    }
  }, {
    key: "token",
    get: function get() {
      if (!this.isAuthenticated) return null;
      return JSON.parse(localStorage.getItem("user-data")).access_token;
    }
  }, {
    key: "id",
    get: function get() {
      if (!this.isAuthenticated) return null;
      return JSON.parse(localStorage.getItem("user-data")).id;
    }
  }, {
    key: "phone",
    get: function get() {
      if (!this.isAuthenticated) return null;
      return JSON.parse(localStorage.getItem("user-data")).phone;
    }
  }, {
    key: "privileged",
    get: function get() {
      if (!this.isAuthenticated) return null;
      return JSON.parse(localStorage.getItem("user-data")).privileged;
    }
  }, {
    key: "login",
    value: function login(_ref) {
      var access_token = _ref.access_token,
          privileged = _ref.privileged,
          phone = _ref.phone;
      localStorage.setItem("user-data", JSON.stringify({
        access_token: access_token,
        privileged: privileged,
        phone: phone
      }));
    }
  }, {
    key: "updateUserData",
    value: function updateUserData(_ref2) {
      var phone = _ref2.phone,
          id = _ref2.id;
      if (!this.isAuthenticated) return;
      var data = JSON.parse(localStorage.getItem("user-data"));
      data.phone = phone;
      data.id = id;
      localStorage.setItem("user-data", JSON.stringify(data));
    }
  }, {
    key: "logout",
    value: function logout() {
      localStorage.clear();
      sessionStorage.clear();
    }
  }]);

  return AuthService;
}();

var authService = new AuthService();
export default authService;